import React, { Component,Fragment } from 'react';
import moment from 'moment';
import Datetime from 'react-datetime';
import { date_format } from '../../../server/constants';
class IncompleteAppDetails extends Component {
    render() {
        const {incompleteReasons,onReasonSelectionChange, onOtherReasonTextChange, onDateChange, incompleteDueDate}=this.props
        return (
            <Fragment>
                <div className="row">
                    <div className="col-xs-12">
                        <label>Please select missing or incorrect information is indicated below:</label>
                        <ul style={{marginLeft: '18px'}}>
                            {(incompleteReasons||[]).map((item,i)=>{
                                return <li key={i}><div className="checkbox">
                                <label><input className="chbox" type="checkbox" checked={item.isApplicable} onChange={(e)=>{
                                    onReasonSelectionChange(e,i);
                                }} />{item.name}</label>
                                {
                                    item.name=='Other:' && item.isApplicable?<div style={{marginLeft:'20px'}}>
                                    <input type="text" className="form-control" value={item.description} onChange={(e)=>{
                                        onOtherReasonTextChange(e,i);
                                    }} /></div>:null
                                }
                                
                            </div></li>
                            })}
                        </ul>
                    </div>
                    <div className="row">
                        <div className="col-xs-7 col-xs-offset-1">
                            <label>Select due date to receive missing information:</label>
                        </div>
                        <div className="col-xs-4">
                                <div className="uploadFileInfo createmenu-month-group">
                                    <div className="input-group">
                                        <Datetime id="incompleteDueDate" timeFormat={false}
                                        dateFormat={sessionStorage.getItem('ROLE')==='ROLE_DISTRICT'?'YYYY/MM/DD': date_format()}
                                            value={incompleteDueDate}
                                            isValidDate={(currentDate)=>{
                                                 let todayDate=moment();
                                                    todayDate.set({hour:0,minute:0,second:0,millisecond:0})
                                                    currentDate.set({hour:0,minute:0,second:0,millisecond:0})
                                                    return todayDate<=currentDate;
                                                }}
                                             onChange={onDateChange}
                                            locale='en-US'
                                            closeOnSelect 
                                            renderInput={(props, openCalendar, closeCalendar) => {
                                                return (
                                                    <Fragment>
                                                        <input className="form-control" {...props} />
                                                        <button type="button" className="input-group-addon" onClick={openCalendar}>
                                                            <i className="fa fa-calendar"> </i>
                                                        </button>
                                                    </Fragment>
                                                );
                                            }}
                                            />
                                    </div>
                                </div>
                            </div>
                    </div>
                </div>                
            </Fragment>
        );
    }
}

export default IncompleteAppDetails;


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/SchoolMealProgram/incompleteAppDetails.jsx